import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { buildGoogleFontsUrl, collectGoogleFontsFromClasses } from '../utilities/googleFonts.js';

const FONT_STYLESHEET_ID = 'new-blog-system-google-fonts';
const PRECONNECT_IDS = {
  css: 'new-blog-system-google-fonts-preconnect-css',
  files: 'new-blog-system-google-fonts-preconnect-files',
};

const ensureLink = (id, attributes) => {
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    document.head.appendChild(link);
  }
  Object.entries(attributes).forEach(([name, value]) => {
    if (value === true) link.setAttribute(name, '');
    else link.setAttribute(name, value);
  });
  return link;
};

const GoogleFontLoader = ({ classes = {}, previewFamilies = [] }) => {
  const fontUrl = useMemo(() => buildGoogleFontsUrl([
    ...collectGoogleFontsFromClasses(classes),
    ...previewFamilies,
  ]), [classes, previewFamilies]);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    ensureLink(PRECONNECT_IDS.css, { rel: 'preconnect', href: 'https://fonts.googleapis.com' });
    ensureLink(PRECONNECT_IDS.files, {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: true,
    });

    const existing = document.getElementById(FONT_STYLESHEET_ID);
    if (!fontUrl) {
      existing?.remove();
      return undefined;
    }

    const stylesheet = ensureLink(FONT_STYLESHEET_ID, { rel: 'stylesheet', href: fontUrl });
    return () => {
      if (stylesheet.getAttribute('href') === fontUrl) stylesheet.remove();
    };
  }, [fontUrl]);

  return null;
};

GoogleFontLoader.propTypes = {
  classes: PropTypes.object,
  previewFamilies: PropTypes.arrayOf(PropTypes.string),
};

export default GoogleFontLoader;
